import { ContentType } from "../../../Presentation/Components/Post/SearchFallback/ContentListItem/ContentListItem.types";

export enum ReactionableObjectEnum {
    POST = ContentType.POST,
    COMMENT = ContentType.COMMENT,
}

export type userReactionsType = {
    objectId: string;
    objectType: ReactionableObjectEnum;
    reactionName: string;
};
